import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.p55_1 = new (HttpStatusCode())(100, 'Continue');
        this.q55_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.r55_1 = new (HttpStatusCode())(102, 'Processing');
        this.s55_1 = new (HttpStatusCode())(200, 'OK');
        this.t55_1 = new (HttpStatusCode())(201, 'Created');
        this.u55_1 = new (HttpStatusCode())(202, 'Accepted');
        this.v55_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.w55_1 = new (HttpStatusCode())(204, 'No Content');
        this.x55_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.y55_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.z55_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.a56_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.b56_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.c56_1 = new (HttpStatusCode())(302, 'Found');
        this.d56_1 = new (HttpStatusCode())(303, 'See Other');
        this.e56_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.f56_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.g56_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.h56_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.i56_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.j56_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.k56_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.l56_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.m56_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.n56_1 = new (HttpStatusCode())(404, 'Not Found');
        this.o56_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.p56_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.q56_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.r56_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.s56_1 = new (HttpStatusCode())(409, 'Conflict');
        this.t56_1 = new (HttpStatusCode())(410, 'Gone');
        this.u56_1 = new (HttpStatusCode())(411, 'Length Required');
        this.v56_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.w56_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.x56_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.y56_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.z56_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.a57_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.b57_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.c57_1 = new (HttpStatusCode())(423, 'Locked');
        this.d57_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.e57_1 = new (HttpStatusCode())(425, 'Too Early');
        this.f57_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.g57_1 = new (HttpStatusCode())(428, 'Precondition Required');
        this.h57_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.i57_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.j57_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.k57_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.l57_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.m57_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.n57_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.o57_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.p57_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.q57_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.r57_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.r57_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().gc(capacity);
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp$ret$2 = element.t57_1;
          destination.b5(tmp$ret$2, element);
        }
        tmp.s57_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.t57_1 = value;
        this.u57_1 = description;
      }
      toString() {
        return '' + this.t57_1 + ' ' + this.u57_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.t57_1 === this.t57_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.t57_1;
      }
      v57(other) {
        return this.t57_1 - other.t57_1 | 0;
      }
      d(other) {
        return this.v57(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().p55_1, Companion_getInstance().q55_1, Companion_getInstance().r55_1, Companion_getInstance().s55_1, Companion_getInstance().t55_1, Companion_getInstance().u55_1, Companion_getInstance().v55_1, Companion_getInstance().w55_1, Companion_getInstance().x55_1, Companion_getInstance().y55_1, Companion_getInstance().z55_1, Companion_getInstance().a56_1, Companion_getInstance().b56_1, Companion_getInstance().c56_1, Companion_getInstance().d56_1, Companion_getInstance().e56_1, Companion_getInstance().f56_1, Companion_getInstance().g56_1, Companion_getInstance().h56_1, Companion_getInstance().i56_1, Companion_getInstance().j56_1, Companion_getInstance().k56_1, Companion_getInstance().l56_1, Companion_getInstance().m56_1, Companion_getInstance().n56_1, Companion_getInstance().o56_1, Companion_getInstance().p56_1, Companion_getInstance().q56_1, Companion_getInstance().r56_1, Companion_getInstance().s56_1, Companion_getInstance().t56_1, Companion_getInstance().u56_1, Companion_getInstance().v56_1, Companion_getInstance().g57_1, Companion_getInstance().w56_1, Companion_getInstance().x56_1, Companion_getInstance().y56_1, Companion_getInstance().z56_1, Companion_getInstance().a57_1, Companion_getInstance().b57_1, Companion_getInstance().c57_1, Companion_getInstance().d57_1, Companion_getInstance().e57_1, Companion_getInstance().f57_1, Companion_getInstance().h57_1, Companion_getInstance().i57_1, Companion_getInstance().j57_1, Companion_getInstance().k57_1, Companion_getInstance().l57_1, Companion_getInstance().m57_1, Companion_getInstance().n57_1, Companion_getInstance().o57_1, Companion_getInstance().p57_1, Companion_getInstance().q57_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceu2wrlss616lb,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
